var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "718.358px",
    height: "718.358px",
    viewBox: "0 0 718.358 718.358",
    enableBackground: "new 0 0 718.358 718.358",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,359.857l359.859,359.861l359.854-359.861L359.859,0L0,359.857z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.85,47.78L47.78,359.85l310.728,310.727l312.07-312.07L359.85,47.78L359.85,47.78z M62.098,361.809l-1.986-1.984 L359.824,60.112l298.422,298.421l-3.277,3.275H62.098L62.098,361.809z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.229,297.5c-3.709,4-10.628,7.807-20.445,7.807c-12.17,0-17.71-3.475-19.839-7.807h-61.395v23.622h157.742V297.5 H266.229L266.229,297.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M341.656,24.647l18.284-18.283l14.1,14.099 M341.656,24.647"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M292.031,74.272l31.346-31.346 M292.031,74.272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M242.585,123.717l31.235-31.237 M242.585,123.717"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M193.214,173.088l31.466-31.465 M193.214,173.088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M143.842,222.459l31.351-31.347 M143.842,222.459"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M94.532,271.772l31.005-31.006 M94.532,271.772"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M45.105,321.197l31.176-31.176 M45.105,321.197"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M36.823,390.4L6.364,359.939l20.661-20.66 M36.823,390.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M86.137,439.711L55.13,408.705 M86.137,439.711"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M135.447,489.023l-31.174-31.176 M135.447,489.023"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M185.164,538.738l-31.522-31.521 M185.164,538.738"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M234.479,588.053l-31.409-31.406 M234.479,588.053"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M283.847,637.422l-31.351-31.35 M283.847,637.422"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M333.049,686.623l-31.463-31.463 M333.049,686.623"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M386.748,683.666c-15.354,15.354-28.331,28.328-28.331,28.328l-7.175-7.178  M386.748,683.666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M436.232,634.182c0,0-14.752,14.752-31.41,31.41 M436.232,634.182"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M485.6,584.813l-31.52,31.52 M485.6,584.813"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M534.857,535.555l-31.465,31.465 M534.857,535.555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M584.115,486.295l-31.008,31.01 M584.115,486.295"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M633.885,436.525l-31.41,31.41 M633.885,436.525"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M683.254,387.156l-31.463,31.463 M683.254,387.156"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M688.855,335.28c14.506,14.505,23.139,23.138,23.139,23.138l-10.889,10.887  M688.855,335.28"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M639.313,285.738c11.363,11.361,21.854,21.852,31.125,31.123  M639.313,285.738"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M589.598,236.023c10.854,10.854,21.428,21.428,31.525,31.526  M589.598,236.023"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M540.285,186.711c10.547,10.547,21.109,21.107,31.52,31.519  M540.285,186.711"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M490.797,137.223c10.334,10.333,20.959,20.958,31.695,31.695  M490.797,137.223"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M441.777,88.203c9.809,9.809,20.338,20.338,31.348,31.348 M441.777,88.203"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    d: "M392.455,38.88c8.141,8.141,18.656,18.657,30.893,30.893 M392.455,38.88"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M510.73,323.318c-25.365,0-13.184,9.18-54.236,9.18 c-5.488,0-15.701-1.021-24.723-1.021c-13.68,0-17.645-1.962-17.645-5.446c0-3.337,3.457-5.383,7.295-5.383 M510.73,323.318"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M443.082,320.648c0,0-24.035,0-31.518,0c-7.48,0-9.861-3.64-9.861-6.187 c0-2.547,2.336-4.502,9.168-4.502 M443.082,320.648"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M437.295,309.959c0,0-33.428,0-38.84,0s-8.697-2.592-8.697-6.572 c0-3.981,4.297-6.208,8.596-6.208c4.297,0,38.998,0,38.998,0 M437.295,309.959"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M408.859,297.18c-5.73,0-5.572-3.821-5.572-5.253 c0-1.434,0.479-5.571,7.164-5.571c5.889,0,39.316,0,43.773,0c4.458,0,12.734-1.91,12.734-1.91 M408.859,297.18"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M474.123,306.094c-8.119,0-21.967-3.821-21.012-19.739 M474.123,306.094"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M510.734,287.469c-6.336,0-14.033,0.44-21.031-1.93 c-5.662-1.914-10.279-6.255-17.969-9.531c-10.027,6.527-24.354,5.573-31.518-2.228c-7.959,3.82-16.873,3.183-16.873,3.183 c0,3.981-1.273,9.392,18.465,9.392 M510.734,287.469"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M507.893,219.074c-3.652,4.397-5.242,6.569-6.236,8.806 c-1.504,3.386,0.104,10.085-0.531,11.099c-1.244,1.988-5.66,2.217-7.4,5.199c-1.74,2.984,0,6.214-0.746,7.955 c-0.744,1.74-5.467,6.213-7.953,7.207 M507.893,219.074"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M486.377,222.482c0,6.613,3.115,8.819,1.52,12.088 c-1.596,3.27-4.486,3.193-5.93,5.702c-1.445,2.509,0.531,8.589-0.152,10.794c-0.689,2.229-3.117,5.17-6.006,7.147 M486.377,222.482"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M437.385,226.865c0,4.346-2.523,8.271-1.822,11.074 c0.701,2.803,5.594,3.961,6.729,6.519c1.402,3.154-0.701,7.289,0.07,9.533c0.771,2.242,3.293,4.625,5.816,7.5 M437.385,226.865"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M418.531,224.482c2.523,3.014,5.117,5.608,6.027,8.41 c0.912,2.805-0.209,9.954,0.631,11.565c0.842,1.613,6.309,3.855,7.08,5.117s0.35,6.87,1.051,8.34 c0.699,1.473,4.766,5.047,6.799,7.01 M418.531,224.482"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M281.742,249.094c-4.196,4.779-5.254,5.435-6.425,8.654 c-1.17,3.221,0.087,10.672-0.694,11.648c-0.779,0.975-5.374,3.198-6.447,4.367c-1.072,1.172-0.717,6.898-1.594,8.459 c-0.878,1.56-6.655,6.934-7.376,7.162 M281.742,249.094"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M263.532,254.143c0,6.311,1.779,10.293,1.386,12.064 c-0.554,2.496-4.438,3.535-5.755,5.408c-1.316,1.871,0.069,10.122-0.484,11.44c-0.555,1.316-4.092,6.309-5.963,7.486  M263.532,254.143"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M224.636,258.65c-0.762,3.813-3.397,8.25-2.565,10.955 c0.832,2.703,6.309,5.753,7.073,7.902c0.762,2.15-0.832,6.866-0.209,9.569c0.625,2.705,3.676,5.476,6.034,7.695 M224.636,258.65"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.5,
    d: "M206.193,250.4c3.606,4.784,4.887,5.86,6.24,8.319 c1.525,2.773-0.416,8.597,0.833,11.164c1.248,2.564,5.685,2.912,7.14,6.1c1.457,3.189,0.208,5.686,1.734,8.529 c1.525,2.842,6.377,5.061,6.377,5.061 M206.193,250.4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M244.811,252.48c0,4.783-5.337,11.717-5.337,18.512c0,4.921,2.009,9.221,4.782,9.221c2.774,0,5.201-3.329,5.201-9.291 C249.457,264.959,244.811,256.016,244.811,252.48L244.811,252.48z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M348.148,185.895c-1.875-10.25-12.75-11.625-22.5-10c0,0-68,12.125-72.125,12.875c-4.125,0.75-7.5,0.625-12.25-4.625 c0,0,4.625,26.375,4.875,29.125c0.25,2.75,0.674,4.475,0.674,4.475c0,4.992-6.101,14.351-6.101,20.801 c0,6.447,2.911,10.607,5.614,10.607c2.705,0,6.102-5.27,6.102-12.204s-4.367-11.51-4.367-14.558c0-3.051,4.777-5.1,6.239-5.547 c1.463-0.449,78.713-13.949,78.713-13.949C342.648,201.145,350.023,196.145,348.148,185.895L348.148,185.895z M332.398,199.645 c-3.992,0.799-6.75,1.25-6.75,1.25l-77,6.875l-2.25-14.5c0,0,77.75-13,82.625-13.875c4.875-0.875,14.125-1.125,15.75,7.375 C346.398,195.27,337.398,198.645,332.398,199.645L332.398,199.645z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M462.271,244.395c0,4.365,4.086,9.271,4.086,15.473c0,4.491-1.811,8.068-4.34,8.068c-2.533,0-4.648-2.577-4.648-8.018 C457.369,254.475,462.271,247.622,462.271,244.395L462.271,244.395z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M465.939,212.104c0.25-2.75,4-28.75,4-28.75c-4.75,5.25-7.457,4.445-11.582,3.695s-78-14.111-78-14.111 c-9.75-1.625-20.875,0.75-22.752,11c-1.875,10.25,7.459,15.75,17.084,17.5c0,0,81.418,13.237,82.881,13.684 c1.463,0.449,5.213,2.425,5.213,5.476c0,3.051-4.137,5.221-4.137,12.153c0,6.934,1.688,9.602,4.391,9.602s5.414-3.05,5.414-9.498 c0-6.449-3.523-8.643-3.523-13.634C464.928,219.219,465.689,214.854,465.939,212.104L465.939,212.104z M386.232,199.174 c0,0-9.469-0.94-13.459-1.737c-5-1-13.625-4.25-12-12.75s13.459-9.293,18.334-8.418c4.875,0.875,86.375,15.28,86.375,15.28 l-2.25,14.5L386.232,199.174L386.232,199.174z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M345.43,562.048c0-3.026,0.842-5.321,2.526-6.889c1.683-1.566,3.957-2.351,6.818-2.351 c2.861,0,5.134,0.784,6.817,2.351c1.684,1.567,2.527,3.862,2.527,6.889c0,2.916-0.828,5.179-2.482,6.786 c-1.654,1.608-3.942,2.412-6.862,2.412c-2.921,0-5.208-0.804-6.862-2.412C346.258,567.227,345.43,564.964,345.43,562.048 L345.43,562.048z M332.243,562.769c0,4.95,1.859,9.163,5.578,12.639c3.719,3.477,9.193,5.214,16.422,5.214 c7.228,0,12.859-1.736,16.891-5.209c4.03-3.473,6.047-7.682,6.047-12.627c0-3.297-0.801-6.282-2.402-8.958 c-1.602-2.675-3.989-4.824-7.159-6.446c3.125-1.623,5.155-3.536,6.093-5.74s1.407-4.267,1.407-6.188 c0-4.273-1.777-7.918-5.33-10.934s-8.567-4.523-15.046-4.523s-11.495,1.507-15.047,4.52c-3.553,3.012-5.327,6.652-5.327,10.921 c0,1.919,0.469,3.979,1.411,6.181c0.941,2.201,2.979,4.248,6.116,6.139c-3.158,1.352-5.557,3.368-7.195,6.047 C333.062,556.479,332.243,559.469,332.243,562.769L332.243,562.769z M346.555,536.765c0-2.315,0.725-4.126,2.176-5.434 c1.451-1.308,3.462-1.96,6.035-1.96c2.602,0,4.613,0.652,6.033,1.96c1.422,1.308,2.131,3.118,2.131,5.434 c0,2.128-0.709,3.866-2.131,5.212c-1.42,1.348-3.432,2.02-6.033,2.02c-2.573,0-4.584-0.672-6.035-2.02 C347.28,540.631,346.555,538.893,346.555,536.765L346.555,536.765z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M345.43,562.048c0-3.026,0.842-5.321,2.526-6.889c1.683-1.566,3.957-2.351,6.818-2.351 c2.861,0,5.134,0.784,6.817,2.351c1.684,1.567,2.527,3.862,2.527,6.889c0,2.916-0.828,5.179-2.482,6.786 c-1.654,1.608-3.942,2.412-6.862,2.412c-2.921,0-5.208-0.804-6.862-2.412C346.258,567.227,345.43,564.964,345.43,562.048 L345.43,562.048z M332.243,562.769c0,4.95,1.859,9.163,5.578,12.639c3.719,3.477,9.193,5.214,16.422,5.214 c7.228,0,12.859-1.736,16.891-5.209c4.03-3.473,6.047-7.682,6.047-12.627c0-3.297-0.801-6.282-2.402-8.958 c-1.602-2.675-3.989-4.824-7.159-6.446c3.125-1.623,5.155-3.536,6.093-5.74s1.407-4.267,1.407-6.188 c0-4.273-1.777-7.918-5.33-10.934s-8.567-4.523-15.046-4.523s-11.495,1.507-15.047,4.52c-3.553,3.012-5.327,6.652-5.327,10.921 c0,1.919,0.469,3.979,1.411,6.181c0.941,2.201,2.979,4.248,6.116,6.139c-3.158,1.352-5.557,3.368-7.195,6.047 C333.062,556.479,332.243,559.469,332.243,562.769L332.243,562.769z M346.555,536.765c0-2.315,0.725-4.126,2.176-5.434 c1.451-1.308,3.462-1.96,6.035-1.96c2.602,0,4.613,0.652,6.033,1.96c1.422,1.308,2.131,3.118,2.131,5.434 c0,2.128-0.709,3.866-2.131,5.212c-1.42,1.348-3.432,2.02-6.033,2.02c-2.573,0-4.584-0.672-6.035-2.02 C347.28,540.631,346.555,538.893,346.555,536.765L346.555,536.765z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg82);
export default __webpack_public_path__ + "static/media/8.2.bc4e3fb78429e356d84e4b42dfc5f22d.svg";
export { ForwardRef as ReactComponent };